import { render, staticRenderFns } from "./PageBrands.vue?vue&type=template&id=65cb18e6&"
import script from "./PageBrands.vue?vue&type=script&lang=js&"
export * from "./PageBrands.vue?vue&type=script&lang=js&"
import style0 from "./PageBrands.vue?vue&type=style&index=0&id=65cb18e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports